import { Injectable, inject } from "@angular/core";
import { FormArray, FormBuilder, FormGroup } from "@angular/forms";
import { BehaviorSubject, Observable } from "rxjs";
import { take } from "rxjs/operators";
import {
  TableFieldType,
  TableItem,
  TableItemForm,
} from "../forms/table-field/table-field.model";
import { DatabaseService } from "../shared/database.service";
import { sortByStringWithEmptyAtEnd } from "../shared/helpers/helper-functions";
import {
  SequentialOrderAction,
  SequentialOrderActionForm,
} from "./sequential-order-actions-model";

@Injectable({
  providedIn: "root",
})
export class SequentialOrderActionsService {
  private fb = inject(FormBuilder);
  private databaseService = inject(DatabaseService);

  private orderSequentialActionsBS$: BehaviorSubject<SequentialOrderAction[]> =
    new BehaviorSubject<SequentialOrderAction[]>([]);
  orderSequentialActions$: Observable<SequentialOrderAction[]> =
    this.orderSequentialActionsBS$.asObservable();
  private ordActionsFormBS$: BehaviorSubject<FormGroup | undefined> =
    new BehaviorSubject(
      new FormGroup(new SequentialOrderActionForm(new SequentialOrderAction())),
    );
  ordActionsForm$: Observable<FormGroup> =
    this.ordActionsFormBS$.asObservable();

  getAll() {
    this.databaseService
      .loadSequenceActions()
      .pipe(take(1))
      .subscribe((forms) => {
        this.orderSequentialActionsBS$.next(
          sortByStringWithEmptyAtEnd(forms, (item) => item.name),
        );
        // this.orderSequentialActionsBS$.next(forms.sort((a, b) => a.name.localeCompare(b.name)));
      });
  }

  addSeqAction(seqAct: SequentialOrderAction) {
    return this.databaseService.addSequentialAction(seqAct);
  }

  orderActionClear() {
    const copy = this.ordActionsFormBS$.getValue();
    copy.controls.name.setValue("");
    copy.controls.renderTag.setValue("");
    (copy.controls.fields as FormArray).clear();

    this.ordActionsFormBS$.next(copy);
  }
  formInflate(index: number) {
    const forms = this.orderSequentialActionsBS$.getValue();
    if (forms && forms.length > index) {
      const data = forms[index];
      this.databaseService
        .findSequentialActionByUuid(data.uuid)
        .subscribe((result) => {
          const form = new FormGroup(new SequentialOrderActionForm(result));
          console.log("Loaded Seq Data", data);
          this.ordActionsFormBS$.next(form);
        });
    }
  }

  addField() {
    const form = this.ordActionsFormBS$.getValue();
    const currentItems = form.controls.fields as FormArray;
    currentItems.push(
      this.fb.group(
        new TableItemForm(
          new TableItem("", TableFieldType.TEXT, "", 0, 1, null, false, true),
        ),
      ),
    );
  }

  deleteField(i: number) {
    const array = this.ordActionsFormBS$.getValue().controls
      .fields as FormArray;
    array.removeAt(i);
  }
}
